var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.readonly
    ? _c(
        "div",
        {
          staticClass: "sfcAddNode",
          class: { vertical: _vm.vertical },
          on: {
            mouseenter: function ($event) {
              $event.stopPropagation()
              return _vm.onMouseenter($event)
            },
            mouseleave: function ($event) {
              $event.stopPropagation()
              return _vm.onMouseleave($event)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "sfcAddNodeBtn",
              class: [_vm.type],
              on: {
                mouseenter: _vm.onAddBtnMouseenter,
                mouseleave: _vm.onAddBtnMouseleave,
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    viewBox: "0 0 1024 1024",
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M896 480H544.8V128h-65.6v352H128v66.4h351.2V896h65.6V546.4H896z",
                    },
                  }),
                ]
              ),
              _c(
                "div",
                {
                  ref: "nodeTypePopover",
                  staticClass: "sfcNodeTypePopover",
                  class: { show: _vm.showNodeTypePopover },
                  style: _vm.nodeTypePopoverStyle,
                },
                [
                  _c("SFCNodeTypeContent", {
                    on: { click: _vm.onNodeTypeClick },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }